import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import "./ManualPage.scss";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import ManualViewPage from "./ManualViewPage.jsx";
import { setSideMenuReducer } from "../../store/slice/sideMenuSlice";
import api from "../../api/api";

function ManualPage() {
  const manualType = useSelector((state) => state.manualTypeChecker.manualType);
  const initialOptions = {};
  const [pageData, setPageData] = useState(initialOptions);
  const [shortCutData, setShortCutData] = useState([]);
  const [requestFailed, setRequestFailed] = useState(false);
  const dispatch = useDispatch();

  const { name } = useParams();
  const hash = decodeURIComponent(window.location.hash)?.replace(/^#/, "");

  useEffect(() => {
    if (name == "no-index") {
      return () => {
        window.scrollTo(0, 0);
      };
    }
    const url = "/" + name;
    axios
      .get(api.manual.select, { params: { url: url } })
      .then((res) => {
        setPageData(res.data);
        setShortCutData(res.data.bookmark);
        dispatch(
          setSideMenuReducer({
            category: res.data.categoryId,
            product: res.data.productId,
            manual: res.data.id,
          })
        );
        // if (res.data.display === "N") {
        //   navigate(""); // 에러페이지로 리다이렉트 고려
        // }
      })
      .catch((error) => {
        // if (error.response.status !== 404) {
        setRequestFailed(true);
        // }
      });
    return () => {
      window.scrollTo(0, 0);
    };
    // eslint-disable-next-line
  }, [name, manualType]);

  if (requestFailed && name != "no-index") {
    window.location.href = `/${manualType}/`;
  }
  if (pageData == initialOptions && !requestFailed)
    if (name != "no-index")
      return (
        <div className="manual-home">
          <div className="manual-container">
            <div className="manual-page-content">
              <section className="manual-content"></section>
            </div>
          </div>
        </div>
      );
  return (
    <>
      <ManualViewPage
        pageData={pageData}
        shortCutData={shortCutData}
        hash={hash}
        compare={false}
      />
    </>
  );
}

export default ManualPage;
